import React,{useState,useEffect,useRef} from 'react';
import { preload, preconnect } from 'react-dom';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom';
import ROUTES from './constants/routes';
import Header from './layout/Header/Header';
import LandingPage from './pages/Home/LandingPage';
import HistoricalTimeline from './pages/Timeline/HistoricalTimeline';
import Credentials from './pages/Credentials/Credentials';
import AboutSite from './pages/AboutSite/AboutSite';
import Scroller from './layout/Scroller/Scroller';
import Footer from './layout/Footer/Footer';
import NotFound from './pages/NotFound/NotFound';

import { PRINCIPLES, TESTIMONIALS } from './pages/Home/content';
import CREDENTIALS from './pages/Credentials/content';
import { IMAGE_PRELOAD, PRECONNECT_ORIGINS } from './constants';
import HEADER from './layout/Header/constants';
const {TYPE} = IMAGE_PRELOAD;

function App() {
  const [scrollPosition, setScrollPosition] = useState(0);
  const [originsPreconnected, setOriginsPreconnected] = useState(false);
  const [imagesPreloaded, setImagesPreloaded] = useState({
    [TYPE.LOGOS]: false,
    [TYPE.PRINCIPLES]: false,
    [TYPE.TESTIMONIALS]: false,
    [TYPE.CREDENTIALS]: false
  });
  
  const appRef = useRef(null);
  useEffect(() => {
    const handleScrollPositionUpdate = () => {
      let position = window.scrollY;
      setScrollPosition(position);
    };

    window.addEventListener("scroll", handleScrollPositionUpdate, {passive: true});
    return () => {
        window.removeEventListener("scroll", handleScrollPositionUpdate);
    };
  },[]);
  useEffect(() => {
    const preconnectOrigins = () => {
      PRECONNECT_ORIGINS.URLS.forEach((url) => {
        preconnect(url);
      });
      setOriginsPreconnected(true);
    }
    const preloadImages = (type) => {
      switch(type){
        case TYPE.LOGOS: {
          Object.values(HEADER.LOGOS).forEach((logo) => {
            preload(logo, {
              as: "image",
              fetchPriority: "high"
            })
          });
          break;
        }
        case TYPE.PRINCIPLES: {
          PRINCIPLES.ICONS.forEach((principleImage) => {
            preload(principleImage, {
              as: "image",
              fetchPriority: "high"
            });
          });
          break;
        }
        case TYPE.TESTIMONIALS: {
          TESTIMONIALS.forEach((recommendation) => {
            preload(recommendation.IMAGE, {
              as: "image",
              fetchPriority: "high"
            });
          });
          break;
        }
        case TYPE.CREDENTIALS: {
          CREDENTIALS.forEach((credential) => {
            preload(credential.image, {
              as: "image",
              fetchPriority: "low"
            });
          });
          break;
        }
        default: {
          return;
        }
      }
      setImagesPreloaded({...imagesPreloaded, [type]: true});
    }
    if(!originsPreconnected){
      preconnectOrigins();
    }
    if(!imagesPreloaded.LOGO){
      preloadImages(TYPE.LOGOS);
    }
    if(!imagesPreloaded.PRINCIPLES){
      preloadImages(TYPE.PRINCIPLES);
    }
    if(!imagesPreloaded.TESTIMONIALS){
      preloadImages(TYPE.TESTIMONIALS);
    }
    if(!imagesPreloaded.CREDENTIALS){
      preloadImages(TYPE.CREDENTIALS);
    }
  }, [originsPreconnected]);

  return (
    <div ref={appRef} style={{overflow: "hidden"}}>
      <Router>
        <Header />
        <Switch>
          <Route exact path={ROUTES.ROOT}>
            <LandingPage testimonialImagesPreloaded={imagesPreloaded[TYPE.TESTIMONIALS]}/>
          </Route>
          <Route exact path={ROUTES.HISTORICAL_TIMELINE}>
            <HistoricalTimeline scrollPosition={scrollPosition}/>
          </Route>
          <Route exact path={ROUTES.ABOUT_ME}>
            <TestComponent text="This is a page about me!"/>
          </Route>
          <Route exact path={ROUTES.ABOUT_SITE}>
            <AboutSite />
          </Route>
          <Route path={ROUTES.HISTORY}>
            <TestComponent text="This is a page about my history!"/>
          </Route>
          <Route path={ROUTES.FRAMEWORKS}>
            <TestComponent text="This is a page about my frameworks!"/>
          </Route>
          <Route path={ROUTES.PROJECTS}>
            <TestComponent text="This is a page about my projects!"/>
          </Route>
          <Route path={ROUTES.CREDENTIALS}>
            <Credentials />
          </Route>
          <Route path={ROUTES.SKILLS}>
            <TestComponent text="This is a page describing my skills!"/>
          </Route>
          <Route path={ROUTES.ROOT}>
            <NotFound />
          </Route>
        </Switch>
        <Scroller scrollPosition={scrollPosition}/>
        <Footer />
      </Router>
    </div>
  );
}

const TestComponent = (props) => {
  return (
    // eslint-disable-next-line react/prop-types
    <div>{props.text}</div>
  )
}

export default App;
